import { render, staticRenderFns } from "./PrintSyntheses.vue?vue&type=template&id=6682f863&"
import script from "./PrintSyntheses.vue?vue&type=script&lang=js&"
export * from "./PrintSyntheses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports